export default __webpack_public_path__ + "static/ai-content-f74c68b0eeb9f407f8cbd6a905d1eb1a.mp4";